module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Rouble-dcbcc56bbc674330597e2e66f33f4ec6.svg";